!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, r = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in r) {
      var i = r[e];
      delete r[e];
      var n = {
        id: e,
        exports: {}
      };
      return t[e] = n, i.call(n.exports, n, n.exports), n.exports;
    }
    var a = new Error("Cannot find module '" + e + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(e, t) {
    r[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("cJzMp", function(e, t) {
    var r, i, n, a;
    r = e.exports, i = "createLogger", n = function() {
      return d;
    }, Object.defineProperty(r, i, {
      get: n,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    const o = "mbf_debug", s = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    function c() {
      const e = {};
      return s.forEach(t => e[t] = !0), {
        enabled: !1,
        categories: e,
        files: {}
      };
    }
    "undefined" != typeof window && function() {
      try {
        const e = localStorage.getItem(o);
        if (!e) return c();
        const t = JSON.parse(e), r = c();
        return r.enabled = !!t.enabled, t.categories && "object" == typeof t.categories && Object.keys(r.categories).forEach(e => {
          e in t.categories && (r.categories[e] = !!t.categories[e]);
        }), t.files && "object" == typeof t.files && (r.files = t.files), r;
      } catch {
        return c();
      }
    }();
    const d = () => () => {};
  });
  var n = i("cJzMp");
  (() => {
    const e = window.MBF = window.MBF || {};
    if (e.swishInitStarted) return;
    e.swishInitStarted = !0;
    const t = (0, n.createLogger)("swish-init");
    t("lifecycle", "bootstrap start", {
      customerId: e.customer?.id ?? null
    });
    const r = "/apps/wishlist/api", i = "swish:pending-item:v1", a = {
      client: null,
      items: [],
      byProduct: new Map
    };
    try {
      Object.keys(localStorage).filter(e => /^esc_/i.test(e)).forEach(e => localStorage.removeItem(e));
    } catch (e) {
      console.warn("[swish] localStorage cleanup failed", e);
    }
    const o = () => {
      document.dispatchEvent(new CustomEvent("swish:wishlistChanged", {
        detail: {
          count: a.items.length,
          productIds: a.items.map(e => e.productId)
        }
      }));
    }, s = async () => {
      var e;
      a.client && (e = await (async () => {
        const e = [];
        let t;
        do {
          const {data: r, error: i, pageInfo: n} = await a.client.items.list({
            limit: 200,
            ...t ? {
              page: t
            } : {}
          });
          if (i) throw i;
          Array.isArray(r) && e.push(...r), t = n?.next || null;
        } while (t);
        return e;
      })(), a.items = Array.isArray(e) ? e : [], a.byProduct = new Map(a.items.map(e => [ Number(e.productId), e ])), 
      o(), t("lifecycle", "refresh complete", {
        itemCount: a.items.length
      }));
    }, c = () => {
      try {
        localStorage.removeItem(i);
      } catch {}
    }, d = async () => {
      const e = (() => {
        try {
          const e = localStorage.getItem(i);
          if (!e) return t("lifecycle", "readPendingItem", {
            outcome: "none"
          }), null;
          const r = JSON.parse(e);
          if (!r || !Number(r.productId) || Date.now() - Number(r.at || 0) > 864e5) return c(), 
          t("lifecycle", "readPendingItem", {
            outcome: Number(r?.productId) ? "expired-cleared" : "invalid-cleared"
          }), null;
          const n = {
            productId: Number(r.productId),
            variantId: r.variantId ? Number(r.variantId) : null
          };
          return t("lifecycle", "readPendingItem", {
            outcome: "found",
            pending: n
          }), n;
        } catch {
          return t("lifecycle", "readPendingItem", {
            outcome: "invalid-cleared"
          }), null;
        }
      })();
      if (!e) return;
      if (a.byProduct.has(e.productId)) return t("network", "replayPendingAdd skipped — already in wishlist", e), 
      c(), void t("events", "pending item key cleared", {
        reason: "already-in-wishlist"
      });
      const r = {
        productId: e.productId,
        quantity: 1,
        ...e.variantId ? {
          variantId: e.variantId
        } : {}
      };
      t("network", "items.create request", r);
      const {data: n, error: s} = await a.client.items.create(r);
      if (s) throw t("network", "items.create error", s), s;
      t("network", "items.create response", n), c(), t("events", "pending item key cleared", {
        reason: "replayed"
      }), n && (a.items = [ ...a.items, n ], a.byProduct.set(Number(n.productId), n), 
      o(), document.dispatchEvent(new CustomEvent("swish:addToWishlist", {
        detail: {
          productId: e.productId,
          variantId: e.variantId
        }
      })), t("events", "swish:addToWishlist dispatched", e));
    };
    e.swish = {
      get items() {
        return a.items;
      },
      hasProduct: e => a.byProduct.has(Number(e)),
      getItem: e => a.byProduct.get(Number(e)),
      async toggleProduct(t, r) {
        if (!e.customer?.id) return {
          guest: !0
        };
        if (await e.swishReady, !a.client) throw new Error("[swish] wishlist API unavailable");
        const i = Number(t), n = a.byProduct.get(i);
        if (n) {
          const {error: e} = await a.client.items.deleteById(n.id);
          if (e) throw e;
          return a.items = a.items.filter(e => Number(e.productId) !== i), a.byProduct.delete(i), 
          o(), {
            added: !1
          };
        }
        const {data: s, error: c} = await a.client.items.create({
          productId: i,
          quantity: 1,
          ...r ? {
            variantId: Number(r)
          } : {}
        });
        if (c) throw c;
        return s && (a.items = [ ...a.items, s ], a.byProduct.set(Number(s.productId), s), 
        o()), {
          added: !0
        };
      },
      refresh: s
    }, e.swishReady = (async () => {
      if (!e.customer?.id) return null;
      try {
        const {createApiClient: e} = await import("https://cdn.jsdelivr.net/npm/@swishapp/api-client@0.44.0/dist/index.js");
        a.client = e({
          config: {
            baseUrl: r
          }
        }), t("network", "API client ready", {
          baseUrl: r
        }), await s();
      } catch (e) {
        return console.warn("[swish] API client failed to load", e), t("errors", "client load failed — pending key kept", e), 
        null;
      }
      try {
        await d();
      } catch (e) {
        console.warn("[swish] could not save pending wishlist item", e), t("errors", "replay failed — pending key cleared", e), 
        c();
      }
      return a.client;
    })();
  })();
}();